<template>
  <div class="container-fluid my-4">

  <div class="row">
    <div class="col-md-3 d-flex justify-content-center align-items-center">
        <CreditScoreGauge :score="this.score" />
    </div>
    <div class="col-md-9 ">
      
      <!-- Fila 1 -->
    <div class="row g-3 mb-3">
      <div class="col-12 col-md-4">
        <CreditHistoryCard
          :equifax-score="puntaje_equifax"
          v-model:points="contrib.equifax"
        />
      </div>

      <div class="col-12 col-md-4">
        <IncomeCard
          :amount="ingresos_mensuales"
          :currency="currency"
          v-model:points="contrib.income"
        />
      </div>

      <div class="col-12 col-md-4">
        <DebtCard
          :debt="dti"
          :income="ingresos_mensuales"
          :currency="currency"
          v-model:points="contrib.debt"
        />
      </div>
    </div>

    <!-- Fila 2 -->
    <div class="row g-3 mb-3">
      <div class="col-12 col-md-4">
        <SeniorityCard
          :quantity="antiguedad_cantidad"
          :unit="antiguedad_unidad"
          v-model:points="contrib.seniority"
        />
      </div>

      <div class="col-12 col-md-4">
        <CollateralCard
          :value="garantia"             
          v-model:points="contrib.collateral"
        />
      </div>

      <div class="col-12 col-md-4">
        <BehaviorCard
            :value="comportamiento"
            :valueScale="10"
            v-model:points="contrib.behavior"
          />
      </div>
    </div>




    </div>


  </div>

    <!-- Fila 3 -->
    <div class="row g-3">
      <div class="col-12">
        <SummaryCard
          :equifaxPoints="contrib.equifax"
          :equifaxRaw="puntaje_equifax"
          :income="ingresos_mensuales"
          :debt="dti"
          :seniorityQty="antiguedad_cantidad"
          :seniorityUnit="antiguedad_unidad"
          :collateral="garantia"
          :behavior="comportamiento"
          :currency="currency"
          :totalScore="totalScore"
          v-model="selectedClass"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CreditHistoryCard from "./cards/CreditHistoryCard.vue";
import IncomeCard from "./cards/IncomeCard.vue";
import DebtCard from "./cards/DebtCard.vue";
import SeniorityCard from "./cards/SeniorityCard.vue";
import CollateralCard from "./cards/CollateralCard.vue";
import BehaviorCard from "./cards/BehaviorCard.vue";
import SummaryCard from "./cards/SummaryCard.vue";
import CreditScoreGauge from "./CreditScoreGauge.vue";

export default {
  name: "ScoreDetails",
  components: {
    CreditHistoryCard,
    IncomeCard,
    DebtCard,
    SeniorityCard,
    CollateralCard,
    BehaviorCard,
    SummaryCard,
    CreditScoreGauge
  },
  props: {
    puntaje_equifax: { type: Number, default: null },
    ingresos_mensuales: { type: Number, default: null },
    dti: { type: Number, default: null }, // monto de deuda total
    antiguedad_cantidad: { type: Number, default: null },
    antiguedad_unidad: { type: String, default: "meses" },
    garantia: { type: Number, default: null },
    comportamiento: { type: Number, default: null },
    currency: { type: String, default: "Lps" },
    // v-model:score
    score: { type: Number, default: 0 }
  },
  data() {
    return {
      contrib: {
        equifax: 0,    // 0–30
        income: 0,     // 0–25
        debt: 0,       // 0–20  ← DTI
        seniority: 0,  // 0–10
        collateral: 0,
        behavior: 0,
      },
      selectedClass: "" 
    };
  },
  computed: {
    totalScore() {
      const c = this.contrib;
      return Number((c.equifax + c.income + c.debt + c.seniority + c.collateral + c.behavior).toFixed(1));
    }
  },
  watch: {
    totalScore: {
      immediate: true,
      handler(val) {
        this.$emit("update:score", val);
      }
    },
    selectedClass: {
      immediate: true,
      handler(newClass) {
        this.$emit("update:class", newClass);
      }
    }
  }
};
</script>
